module.exports = __webpack_public_path__ + "static/media/storeAddress.a1da3b7e.svg";